export default __webpack_public_path__ + "static/media/Helvetica-Light.2178e08f.ttf";